"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.preview.title': 'Price Package Details',
    'accountGrade.preview.back': 'Back to Price Packages',
    'accountGrade.preview.edit': 'Edit Price Package',
    'accountGrade.preview.delete': 'Delete Price Package',
    'accountGrade.preview.enabled': 'Enabled',
    'accountGrade.preview.disabled': 'Disabled',
    'accountGrade.preview.no_data': 'No price package data available',
    'accountGrade.preview.error.load_failed': 'Failed to load price package for preview',
    'accountGrade.preview.unnamed': 'Unnamed Price Package',
    'accountGrade.preview.no_description': 'No description provided',
    'accountGrade.preview.price': 'Price per month',
    'accountGrade.preview.free': 'Free',
    'accountGrade.preview.cents': 'cents',
    'accountGrade.preview.active_status': 'Status',
    'accountGrade.preview.order': 'Display Order',
};
